<div class='admissions-prospects-tab3-part'>
	<staff-engagement-counts [data]="staffEngagementData()"></staff-engagement-counts>
</div>